import React from 'react';
import SectionTitle from './SectionTitle';
import ScrollReveal from './ScrollReveal';

const ArticlesSection = () => {
  return (
    <section id="articles" className="section" style={styles.section}>
      <ScrollReveal>
        <SectionTitle text="ARTICLES" />
      </ScrollReveal>

      <div style={styles.articlesGrid}>
        <ScrollReveal delay={300}>
          <div style={styles.articleCard}>
            <div style={styles.articleTitle}>Crush Testing Cursor: Does Coding on Autopilot Mean Security on Standby?</div>
            <div style={styles.articleMeta}>
              <span style={styles.articleDate}>OX Security</span>
              <span style={styles.articleTags}>#security #AI #cursor</span>
            </div>
            <div style={styles.articleSummary}>
              An analysis of Cursor's security implications as an AI-powered code editor. The article examines the potential security risks when developers rely on AI assistance for coding tasks.
            </div>
            <a href="https://www.ox.security/crush-testing-cursor-does-coding-on-autopilot-mean-security-on-standby/" 
               target="_blank" 
               rel="noopener noreferrer" 
               style={styles.readMoreLink}>READ MORE →</a>
          </div>
        </ScrollReveal>
        
        <ScrollReveal delay={500}>
          <div style={{...styles.articleCard, ...styles.emptyCard}}>
            <div style={styles.placeholderContent}>
              <div style={styles.placeholderIcon}>⌛</div>
              <div style={styles.placeholderText}>More articles coming soon</div>
            </div>
          </div>
        </ScrollReveal>
        
        <ScrollReveal delay={700}>
          <div style={{...styles.articleCard, ...styles.emptyCard}}>
            <div style={styles.placeholderContent}>
              <div style={styles.placeholderIcon}>⌛</div>
              <div style={styles.placeholderText}>More articles coming soon</div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '3rem 1rem',
    maxWidth: '1200px',
    margin: '0 auto 4rem',
    position: 'relative',
  },
  articlesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
  },
  articleCard: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '1px solid #f0f', // Neon pink
    padding: '1.5rem',
    borderRadius: '5px',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 0 15px rgba(255, 0, 255, 0.5)',
    }
  },
  emptyCard: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Darker background for empty cards
    borderColor: 'rgba(255, 0, 255, 0.3)', // Dimmed border for empty cards
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '240px',
  },
  placeholderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.6,
    padding: '2rem',
  },
  placeholderIcon: {
    fontSize: '2.5rem',
    marginBottom: '1rem',
    color: '#f0f',
  },
  placeholderText: {
    color: '#f0f',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  articleTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#f0f', // Neon pink
    marginBottom: '0.5rem',
    textShadow: '0 0 5px rgba(255, 0, 255, 0.5)',
  },
  articleMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem',
    fontSize: '0.9rem',
  },
  articleDate: {
    color: '#0ff', // Neon blue
  },
  articleTags: {
    color: '#ff0', // Neon yellow
  },
  articleSummary: {
    color: '#e0e0e0',
    marginBottom: '1.5rem',
    lineHeight: '1.5',
    flexGrow: 1,
  },
  readMoreLink: {
    color: '#f0f', // Neon pink
    textDecoration: 'none',
    borderBottom: '1px solid #f0f',
    paddingBottom: '0.2rem',
    transition: 'all 0.3s ease',
    alignSelf: 'flex-start',
    ':hover': {
      textShadow: '0 0 5px #f0f',
    }
  }
};

export default ArticlesSection; 